import { Loader2 } from "lucide-react";
import { cn } from "@/lib/cn";

export function Spinner({ className, label }: { className?: string; label?: string }) {
  return (
    <output className={cn("inline-flex items-center", className)} aria-label={label}>
      <Loader2 className="size-full animate-spin" aria-hidden />
    </output>
  );
}
